import * as React from "react"
import { cn } from "@/lib/utils"

const FormDescription = React.forwardRef(({ className, icon, ...props }, ref) => {
  return (
    <p
      ref={ref}
      className={cn("text-sm text-muted-foreground", className)}
      {...props}
    />
  )
})
FormDescription.displayName = "FormDescription"

export { FormDescription }
